import { Dayjs, isDayjs } from 'dayjs';

export enum publishTimes {
  NOW = 'now',
  SCHEDULE = 'schedule',
}

export const formatScheduledTime = (type: publishTimes, datetime?: Dayjs): string | undefined => {
  if (type !== publishTimes.SCHEDULE) {
    return undefined;
  }
  return isDayjs(datetime) ? datetime.format('YYYY-MM-DD HH:mm:ss') : undefined;
};
